module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Underdog-2007.f639155.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Underdog-2007.jpg
// module id = qXB1
// module chunks = 0